import {create} from 'zustand';
import {UseIsSubmittingSelectionStoreType} from './types';

export const useIsSubmittingSelectionStore = create<UseIsSubmittingSelectionStoreType>(set => ({
	isSubmittingSelection: false,
	setIsSubmittingSelection: isSubmitting => set({isSubmittingSelection: isSubmitting}),
}));
